import { render, staticRenderFns } from "./FormBaseSideBar.vue?vue&type=template&id=41614e62&"
import script from "./FormBaseSideBar.vue?vue&type=script&lang=js&"
export * from "./FormBaseSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports